module.exports = __webpack_public_path__ + "static/demo-screen-1-d7a075af607934669cfd5862482fb338.jpg";